import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAnimatedGridOverlay, LazyFooter, LazyHeader, LazyHeatPumpFive, LazyNewPreview, LazySolarFormFive, LazySolarFormFour, LazySolarFormOne, LazySolarFormStart, LazySolarFormThree, LazySolarFormTwo, LazyVimeo, LazyHeadingsH1, LazyHeadingsH2, LazyHeadingsH3, LazyHeadingsH4, LazyHeadingsH5, LazyHeadingsH6, LazyCaseStudiesArticleTemplate, LazyCaseStudiesCategoryTemplate, LazyCaseStudiesTemplate, LazyEPCButtonComponent, LazyEPCCallToActionBlock, LazyEPCCaseStudiesCarouselBlock, LazyEPCCertifiedBlock, LazyEPCComparisonBlock, LazyEPCFeatureCardsBlock, LazyEPCFormBlock, LazyEPCFormCheckboxesComponent, LazyEPCFormEmailComponent, LazyEPCFormFileComponent, LazyEPCFormHeadingComponent, LazyEPCFormNumberComponent, LazyEPCFormSubmitComponent, LazyEPCFormTelComponent, LazyEPCFormTextComponent, LazyEPCFormTextareaComponent, LazyEPCFormWithMapBlock, LazyEPCHeroAnimationBlock, LazyEPCHeroBlock, LazyEPCHeroMapBlock, LazyEPCHeroTextAndFormBlock, LazyEPCHeroTextAndImageBlock, LazyEPCHeroWithImageBlock, LazyEPCHerowithFinMatchBlock, LazyEPCHomepageV1Block, LazyEPCImageBlock, LazyEPCImageComponent, LazyEPCLogoCarouselBlock, LazyEPCMembersBlock, LazyEPCNewsreelCarouselBlock, LazyEPCOlListComponent, LazyEPCOurInstallationNetworkBlock, LazyEPCQuoteBlock, LazyEPCQuoteComponent, LazyEPCReviewsBlock, LazyEPCRichtextComponent, LazyEPCSignpostBlock, LazyEPCSolarAdvisoryComparisonBlock, LazyEPCSolarAssessmentBlock, LazyEPCSolarCampaignHeroBlock, LazyEPCSolarCaseStudiesBlock, LazyEPCSolarEnergyFlowBlock, LazyEPCSolarEstimatorBlock, LazyEPCSolarFaqBlock, LazyEPCSolarFinanceBlock, LazyEPCSolarMadeSimpleBlock, LazyEPCSolarModernV3Block, LazyEPCSolarOutcomeBlock, LazyEPCSolarPackagesV2Block, LazyEPCSolarPopularOffersBlock, LazyEPCSolarProductsBlock, LazyEPCSolarSavingsBlock, LazyEPCSolarTrustStripBlock, LazyEPCSolarVideoTestimonialsBlock, LazyEPCSolarWhyBlock, LazyEPCStepsBlock, LazyEPCTabImageComponent, LazyEPCTabTextComponent, LazyEPCTabVideoComponent, LazyEPCTextBlock, LazyEPCTextWithAnimationBlock, LazyEPCTextWithCTABlock, LazyEPCTextWithCardColumnsBlock, LazyEPCTextWithFaqsBlock, LazyEPCTextWithFeatureColumnsBlock, LazyEPCTextWithImageBlock, LazyEPCTextWithOlListBlock, LazyEPCTextWithPriceCardColumnsBlock, LazyEPCTextWithProductsBlock, LazyEPCTextWithQuoteBlock, LazyEPCTextWithRowsBlock, LazyEPCTextWithStatsColumnsBlock, LazyEPCTextWithTableBlock, LazyEPCTextWithTabsBlock, LazyEPCTextWithTextColumnsBlock, LazyEPCTextWithUlListBlock, LazyEPCTimelineBlock, LazyEPCTitleBlock, LazyEPCUlListComponent, LazyEPCVideoBlock, LazyEPCWhatsIncludedBlock, LazyEPCiFrameBlock, LazyLandingTemplate, LazyNewsArticleTemplate, LazyNewsCategoryTemplate, LazyNewsTemplate, LazyPageTemplate, LazyQuoteTemplate, LazySection } from '#components'
const lazyGlobalComponents = [
  ["AnimatedGridOverlay", LazyAnimatedGridOverlay],
["Footer", LazyFooter],
["Header", LazyHeader],
["HeatPumpFive", LazyHeatPumpFive],
["NewPreview", LazyNewPreview],
["SolarFormFive", LazySolarFormFive],
["SolarFormFour", LazySolarFormFour],
["SolarFormOne", LazySolarFormOne],
["SolarFormStart", LazySolarFormStart],
["SolarFormThree", LazySolarFormThree],
["SolarFormTwo", LazySolarFormTwo],
["Vimeo", LazyVimeo],
["HeadingsH1", LazyHeadingsH1],
["HeadingsH2", LazyHeadingsH2],
["HeadingsH3", LazyHeadingsH3],
["HeadingsH4", LazyHeadingsH4],
["HeadingsH5", LazyHeadingsH5],
["HeadingsH6", LazyHeadingsH6],
["CaseStudiesArticleTemplate", LazyCaseStudiesArticleTemplate],
["CaseStudiesCategoryTemplate", LazyCaseStudiesCategoryTemplate],
["CaseStudiesTemplate", LazyCaseStudiesTemplate],
["EPCButtonComponent", LazyEPCButtonComponent],
["EPCCallToActionBlock", LazyEPCCallToActionBlock],
["EPCCaseStudiesCarouselBlock", LazyEPCCaseStudiesCarouselBlock],
["EPCCertifiedBlock", LazyEPCCertifiedBlock],
["EPCComparisonBlock", LazyEPCComparisonBlock],
["EPCFeatureCardsBlock", LazyEPCFeatureCardsBlock],
["EPCFormBlock", LazyEPCFormBlock],
["EPCFormCheckboxesComponent", LazyEPCFormCheckboxesComponent],
["EPCFormEmailComponent", LazyEPCFormEmailComponent],
["EPCFormFileComponent", LazyEPCFormFileComponent],
["EPCFormHeadingComponent", LazyEPCFormHeadingComponent],
["EPCFormNumberComponent", LazyEPCFormNumberComponent],
["EPCFormSubmitComponent", LazyEPCFormSubmitComponent],
["EPCFormTelComponent", LazyEPCFormTelComponent],
["EPCFormTextComponent", LazyEPCFormTextComponent],
["EPCFormTextareaComponent", LazyEPCFormTextareaComponent],
["EPCFormWithMapBlock", LazyEPCFormWithMapBlock],
["EPCHeroAnimationBlock", LazyEPCHeroAnimationBlock],
["EPCHeroBlock", LazyEPCHeroBlock],
["EPCHeroMapBlock", LazyEPCHeroMapBlock],
["EPCHeroTextAndFormBlock", LazyEPCHeroTextAndFormBlock],
["EPCHeroTextAndImageBlock", LazyEPCHeroTextAndImageBlock],
["EPCHeroWithImageBlock", LazyEPCHeroWithImageBlock],
["EPCHerowithFinMatchBlock", LazyEPCHerowithFinMatchBlock],
["EPCHomepageV1Block", LazyEPCHomepageV1Block],
["EPCImageBlock", LazyEPCImageBlock],
["EPCImageComponent", LazyEPCImageComponent],
["EPCLogoCarouselBlock", LazyEPCLogoCarouselBlock],
["EPCMembersBlock", LazyEPCMembersBlock],
["EPCNewsreelCarouselBlock", LazyEPCNewsreelCarouselBlock],
["EPCOlListComponent", LazyEPCOlListComponent],
["EPCOurInstallationNetworkBlock", LazyEPCOurInstallationNetworkBlock],
["EPCQuoteBlock", LazyEPCQuoteBlock],
["EPCQuoteComponent", LazyEPCQuoteComponent],
["EPCReviewsBlock", LazyEPCReviewsBlock],
["EPCRichtextComponent", LazyEPCRichtextComponent],
["EPCSignpostBlock", LazyEPCSignpostBlock],
["EPCSolarAdvisoryComparisonBlock", LazyEPCSolarAdvisoryComparisonBlock],
["EPCSolarAssessmentBlock", LazyEPCSolarAssessmentBlock],
["EPCSolarCampaignHeroBlock", LazyEPCSolarCampaignHeroBlock],
["EPCSolarCaseStudiesBlock", LazyEPCSolarCaseStudiesBlock],
["EPCSolarEnergyFlowBlock", LazyEPCSolarEnergyFlowBlock],
["EPCSolarEstimatorBlock", LazyEPCSolarEstimatorBlock],
["EPCSolarFaqBlock", LazyEPCSolarFaqBlock],
["EPCSolarFinanceBlock", LazyEPCSolarFinanceBlock],
["EPCSolarMadeSimpleBlock", LazyEPCSolarMadeSimpleBlock],
["EPCSolarModernV3Block", LazyEPCSolarModernV3Block],
["EPCSolarOutcomeBlock", LazyEPCSolarOutcomeBlock],
["EPCSolarPackagesV2Block", LazyEPCSolarPackagesV2Block],
["EPCSolarPopularOffersBlock", LazyEPCSolarPopularOffersBlock],
["EPCSolarProductsBlock", LazyEPCSolarProductsBlock],
["EPCSolarSavingsBlock", LazyEPCSolarSavingsBlock],
["EPCSolarTrustStripBlock", LazyEPCSolarTrustStripBlock],
["EPCSolarVideoTestimonialsBlock", LazyEPCSolarVideoTestimonialsBlock],
["EPCSolarWhyBlock", LazyEPCSolarWhyBlock],
["EPCStepsBlock", LazyEPCStepsBlock],
["EPCTabImageComponent", LazyEPCTabImageComponent],
["EPCTabTextComponent", LazyEPCTabTextComponent],
["EPCTabVideoComponent", LazyEPCTabVideoComponent],
["EPCTextBlock", LazyEPCTextBlock],
["EPCTextWithAnimationBlock", LazyEPCTextWithAnimationBlock],
["EPCTextWithCTABlock", LazyEPCTextWithCTABlock],
["EPCTextWithCardColumnsBlock", LazyEPCTextWithCardColumnsBlock],
["EPCTextWithFaqsBlock", LazyEPCTextWithFaqsBlock],
["EPCTextWithFeatureColumnsBlock", LazyEPCTextWithFeatureColumnsBlock],
["EPCTextWithImageBlock", LazyEPCTextWithImageBlock],
["EPCTextWithOlListBlock", LazyEPCTextWithOlListBlock],
["EPCTextWithPriceCardColumnsBlock", LazyEPCTextWithPriceCardColumnsBlock],
["EPCTextWithProductsBlock", LazyEPCTextWithProductsBlock],
["EPCTextWithQuoteBlock", LazyEPCTextWithQuoteBlock],
["EPCTextWithRowsBlock", LazyEPCTextWithRowsBlock],
["EPCTextWithStatsColumnsBlock", LazyEPCTextWithStatsColumnsBlock],
["EPCTextWithTableBlock", LazyEPCTextWithTableBlock],
["EPCTextWithTabsBlock", LazyEPCTextWithTabsBlock],
["EPCTextWithTextColumnsBlock", LazyEPCTextWithTextColumnsBlock],
["EPCTextWithUlListBlock", LazyEPCTextWithUlListBlock],
["EPCTimelineBlock", LazyEPCTimelineBlock],
["EPCTitleBlock", LazyEPCTitleBlock],
["EPCUlListComponent", LazyEPCUlListComponent],
["EPCVideoBlock", LazyEPCVideoBlock],
["EPCWhatsIncludedBlock", LazyEPCWhatsIncludedBlock],
["EPCiFrameBlock", LazyEPCiFrameBlock],
["LandingTemplate", LazyLandingTemplate],
["NewsArticleTemplate", LazyNewsArticleTemplate],
["NewsCategoryTemplate", LazyNewsCategoryTemplate],
["NewsTemplate", LazyNewsTemplate],
["PageTemplate", LazyPageTemplate],
["QuoteTemplate", LazyQuoteTemplate],
["Section", LazySection],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
